/**
 * Headers for our own /api endpoints: JSON plus the coach's session token.
 * Dev Studio AI, Film Studio AI, uploads and resource enrichment now require
 * a signed-in user (they used to be open to anyone with the URL: PQ-06,
 * PQ-10), so every caller goes through this.
 */
import { accessToken } from "../../supabaseClient";

export async function assistHeaders() {
  const token = await accessToken();   // signed out: no token, and the endpoint answers 401
  return { "Content-Type": "application/json", ...(token ? { Authorization: `Bearer ${token}` } : {}) };
}
